import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { User } from '../modal/user';
import { PaymentDetails } from '../modal/payment';


@Injectable({
    providedIn: 'root'
})

export class PaymentService {

    constructor(private httpclient: HttpClient, private global: Globals) { }



    paymentDetails(paymentdetails){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);

        return this.httpclient.post<PaymentDetails>(this.global.G_apiUrl + "/payment/payment-details",paymentdetails,{headers:headers});

    }
    
}